import { render } from "./SalePayView.vue?vue&type=template&id=038c1be2&scoped=true"
import script from "./SalePayView.vue?vue&type=script&lang=js"
export * from "./SalePayView.vue?vue&type=script&lang=js"

import "./SalePayView.vue?vue&type=style&index=0&id=038c1be2&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038c1be2"]])

export default __exports__